import React, { PureComponent } from 'react';
import MarkdownIt from 'markdown-it';

const markdownRenderer = new MarkdownIt({ breaks: true, html: false, linkify: true });

const hasMarkdownImage = preview => {
  // source: https://stackoverflow.com/a/36392520
  // eslint-disable-next-line no-useless-escape
  return preview && preview.match(/!\[[^\]]+\]\([^)]+\)/);
};

export default class MarkdownMessage extends PureComponent {
  render() {
    const { text, isPreview } = this.props;
    if (isPreview && hasMarkdownImage(text)) return <span>Sent a message with an image</span>;
    const html = markdownRenderer.renderInline(text);
    return <span dangerouslySetInnerHTML={{ __html: html }} />; // eslint-disable-line
  }
}

MarkdownMessage.propTypes = {
  isPreview: React.PropTypes.bool,
  text: React.PropTypes.string,
};

MarkdownMessage.defaultProps = {
  isPreview: false,
  text: '',
};
